// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/** Claims do access token (HS256, 1h). `permissions` = array de permissoes.id. Fonte de authz (ADR-b). */
export const accessTokenClaimsSchema = z.object({
  userId: z.number(),
  roleId: z.number(),
  permissions: z.array(z.number()),
  linkedUserIds: z.array(z.number()).optional(),
  jti: z.string(),
  iat: z.number(),
  exp: z.number(),
  iss: z.literal('senne-liquor'),
  aud: z.literal('senne-api'),
})
export type AccessTokenClaims = z.infer<typeof accessTokenClaimsSchema>
